import { styled } from "@mui/material";
import { fonts } from "@constants/cssVariables";

export const ListItem = styled("li")({
  font: fonts.bodyMedium,
});
